import { Paper, Switch, Typography } from "@mui/material";
import { FILTER_BAR_HEIGHT } from "../../theme/dimensions";

export type NavigationMode = "shift" | "period";

interface NavigationModeToggleProps {
  value: NavigationMode;
  onChange: (value: NavigationMode) => void;
}

export const NavigationModeToggle = ({
  value,
  onChange,
}: NavigationModeToggleProps) => (
  <Paper
    elevation={2}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      px: 1.5,
      height: FILTER_BAR_HEIGHT,
      userSelect: "none",
    }}
  >
    <Typography
      variant="body2"
      onClick={() => onChange("period")}
      sx={{
        cursor: "pointer",
        fontWeight: 600,
        color: value === "period" ? "primary.main" : "text.secondary",
      }}
    >
      Period
    </Typography>
    <Switch
      checked={value === "shift"}
      onChange={() => onChange(value === "shift" ? "period" : "shift")}
      size="small"
    />
    <Typography
      variant="body2"
      onClick={() => onChange("shift")}
      sx={{
        cursor: "pointer",
        fontWeight: 600,
        color: value === "shift" ? "primary.main" : "text.secondary",
      }}
    >
      Shift
    </Typography>
  </Paper>
);
